import playerUp    from './player/player-up.png';
import playerDown  from './player/player-down.png';
import playerLeft  from './player/player-left.png';
import playerRight from './player/player-right.png';

const DIR_MAP = {
  up:    playerUp,
  down:  playerDown,
  left:  playerLeft,
  right: playerRight,
};

const DIRS = Object.keys(DIR_MAP);

/**
 * Convert a facing angle (radians) to one of four cardinal directions.
 *
 * Angle conventions used by the game:
 *   0       → up    (moving toward decreasing y)
 *   +π/2    → right
 *   ±π      → down
 *   -π/2    → left
 *   default → -π/2 (left, from createInitialState)
 */
function toDir(angle) {
  // Normalise to (-π, π]
  let a = angle % (2 * Math.PI);
  if (a >  Math.PI) a -= 2 * Math.PI;
  if (a < -Math.PI) a += 2 * Math.PI;

  if (a >= -Math.PI / 4  && a <  Math.PI / 4)  return 'up';
  if (a >=  Math.PI / 4  && a <  3 * Math.PI / 4) return 'right';
  if (a < -3 * Math.PI / 4 || a >= 3 * Math.PI / 4) return 'down';
  return 'left';
}

/**
 * KnightA — directional player sprite using PNG assets.
 *
 * All four directional images are always present in the SVG so the browser
 * fetches them all on first mount. Direction changes only toggle visibility —
 * no href mutation, no extra network requests.
 *
 * Props:
 *   facingAngle  — radians; picks the correct directional PNG
 *   size         — width (and height if `height` is omitted) in px (default 25)
 *   height       — explicit height override for non-square renders (e.g. ARPG 34×48)
 *
 * Returns an inline SVG embedding the PNG so the component renders correctly
 * in both plain HTML (GameWorld div) and SVG (ARPGWorld <g>) contexts.
 */
export default function KnightA({ facingAngle = 0, size = 25, height: hProp, isMoving = true }) {
  const h   = hProp ?? size;
  const dir = isMoving ? toDir(facingAngle) : 'up';
  return (
    <svg
      width={size}
      height={h}
      style={{ display: 'block', overflow: 'visible' }}
    >
      {DIRS.map(d => (
        <image
          key={d}
          href={DIR_MAP[d]}
          x={0} y={0}
          width={size} height={h}
          preserveAspectRatio="none"
          style={{ display: d === dir ? undefined : 'none' }}
        />
      ))}
    </svg>
  );
}
